<template>
  <info-container title="Internal note">
    <div class="tw-flex tw-flex-col">
      <textarea
        class="tw-mt-2 tw-p-2 tw-border tw-border-gray-200 tw-w-[400px]"
        rows="3"
        :disabled="isLoading"
        :value="value"
        @input="onInputChange"
      ></textarea>

      <button class="tw-bg-gray-500 tw-rounded tw-p-1 tw-text-white tw-mt-5" @click="onSaveClick">
        Update info
      </button>
    </div>
  </info-container>
</template>

<script setup>
import InfoContainer from '@/components/shared/InfoContainer.vue'

const props = defineProps({
  value: String,
  isLoading: Boolean,
})

const emit = defineEmits(['input', 'saveLayout'])

const onInputChange = (event) => {
  emit('input', event.target.value)
}

const onSaveClick = () => {
  emit('saveLayout', props.value)
}
</script>
